import { createContext, useContext, useState, useEffect, useCallback } from "react";
import fanApi from "@/lib/fanApi";

const FanAuthContext = createContext(null);

export const useFanAuth = () => useContext(FanAuthContext);

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export const startGoogleLogin = () => {
  const redirectUrl = window.location.origin + window.location.pathname;
  window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
};

export function FanAuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const res = await fanApi.get("/fan-auth/me");
      setUser(res.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    checkAuth();
  }, [checkAuth]);

  const logout = async () => {
    await fanApi.post("/fan-auth/logout").catch(() => {});
    localStorage.removeItem("fan_token");
    setUser(null);
  };

  return (
    <FanAuthContext.Provider value={{ user, setUser, loading, logout, login: startGoogleLogin }}>
      {children}
    </FanAuthContext.Provider>
  );
}
